// src/pages/common/COM101F1.jsx
import React, {useContext, useEffect, useRef, useState} from 'react';
import {useCookies} from "react-cookie";
import {useNavigate} from 'react-router-dom';

import {clearAuthHeader, setAuthHeader} from 'config/axiosConfig'

import {AuthContext} from "contexts/AuthContext"
import {postData} from 'utils/TransactionUtil';
import toast from "components/Toast/Toast";
import Icon from "components/Icon/Icon";
import Checkbox from "components/Checkbox/Checkbox";
import Modal from "components/Modal/Modal";

import COM102M1 from "pages/COM/COM102M1";

import style from './COM101F1.module.scss'


import Login_symbol from "assets/images/sta_Login_symbol_03.svg";
import TILDE_CI_01 from "assets/images/sta_TILDE_CI_01.svg";
//import MSU101F4 from "../MS/MSU101F4";
import COM120M1 from "./COM120M1";

const COM101F1 = () => {

  const authContext = useContext(AuthContext);
  const navigate = useNavigate();

  const saveIdRef = useRef();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [lginId, setLginId] = useState('');
  const [userPw, setUserPw] = useState('');

  const lginIdInputRef = useRef(); //ID 참조 오프젝트
  const userPwInputRef = useRef(); //PW 참조 오프젝트

  const [cookies, setCookie, rmCookie] = useCookies(["rmbLginId","rmbUserPw"]); //Cookies 이름
  const [isRmbId, setIsRmbId] = useState(false); //ID 저장
  const [isRmbPw, setIsRmbPw] = useState(false); //PW 저장

  const [isModalChangePw, setIsModalChangePw] = useState(false); //암호초기화

  //팝업 닫기
  const handleModalChangePw_Close = () => {
    setIsModalChangePw(false);
  }



  /*쿠키 읽어 오기*/
  useEffect(() => {
    /*저장된 쿠키값이 있으면, CheckBox TRUE 및 UserID에 값 셋팅*/
    if (cookies.rmbLginId !== undefined) {
      setLginId(cookies.rmbLginId);
      setIsRmbId(true);
    }

    // if (cookies.rmbUserPw !== undefined) {
    //   setUserPw(cookies.rmbUserPw);
    //   setIsRmbPw(true);
    // }
  }, [cookies]);


  //ID 저장 체크박스 클릭
  const handleSave_id__checkbox = (e) => {
    setIsRmbId(e.target.checked);
    if (e.target.checked){
      setCookie("rmbLginId", lginId, { maxAge: 2000 });
    }else{
      rmCookie("rmbLginId");
    }
  }

  //PW 저장 체크박스 클릭
  const handleSave_pw__checkbox = (e) => {
    setIsRmbPw(e.target.checked);
    if (e.target.checked){
      setCookie("rmbUserPw", userPw, { maxAge: 2000 });
    }else{
      rmCookie("rmbUserPw");
    }
  }

  // 비밀번호에서 엔터키
  const handleKeyDown_password = (e) => {
    if (e.key === 'Enter') {
      //actionLogin().then(r => {});
      preLoginAuthCheck().then(r => {});


    }
  };

  //로그인 버튼 클릭
  const handleClick_Login = (e) => {
    e.preventDefault();

    if(!lginId){
      toast({ type: 'info', message: '아이디를 입력하세요.', opt: { position: "top-center"} });
      return lginIdInputRef.current.focus(); //input에 focus
    }

    if(!userPw){
      toast({ type: 'info', message: '비밀번호를 입력하세요.', opt: { position: "top-center"} });
      return userPwInputRef.current.focus(); //input에 focus
    }


    //actionLogin().then(r => {});

    //preLoginAuthCheck().then(() => {});
    preLoginAuthCheck().then(r => {});


  };

//로그인 하기 함수
  async function preLoginAuthCheck() {
    /*
      1. 관리자 암호 생성 id/pw변경 확인
         - 암호변경
      2. 로그인 10회 실패시 10분 접속 금지
    */

    const param = {
      userId : lginId,
      userPw : userPw
    }

    let result = await postData("/preLoginAuthCheck", param);
    //toast({ type: 'info', message: '비밀번호를 입력하세요.', opt: { position: "top-center"} });
    if(result.retryLoginYn==='N'){
      alert("로그인 실패 횟수를 초과하여 일시적으로 제한되었습니다.\n잠시 후 다시 시도해 주세요.");
    }else{
      if(result.passCheck==="Y" && result.mngrPassMdfcYn === "Y"){
        //사용자 암호변경 프로세스
        setIsModalChangePw(true);
      }else{
        actionLogin().then(r => {});

      }
    }
  }

  //로그인 하기 함수
  async function actionLogin(){

    // 로그인 전 로컬 데이터 초기화
    clearAuthHeader(); // 헤더값 비우기
    localStorage.clear();
    sessionStorage.clear();
    //ID 쿠키에 저장 하기
    isRmbId ? setCookie("rmbLginId", lginId, { maxAge: 2000 }) : rmCookie("rmbLginId");
    //PW 쿠키에 저장 하기
    isRmbPw ? setCookie("rmbUserPw", userPw, { maxAge: 2000 }) : rmCookie("rmbUserPw");
    let param = {
      lginId: lginId,
      userPw: userPw
    }
    postData("/actionLogin",param).then((data) => {
      if (data.res === 0) {
        succeLogin(data);
      }else if (data.res === 9) { // 중복로그인
        if(window.confirm("이미 로그인되어 있습니다.\n 기존 로그인을 종료 하고 다시 로그인 하시겠습니까?")){ //문구수정  필요
          postData("/reActionLogin",param).then((data) => {
            if (data.res === 0) {
              succeLogin(data);
            }
          });
        }
      }else{
        alert("아이디와 비밀번호를 확인해 주세요.");
      }
    });
  }
  //로그인 성공 (보안 기능 추가 필요)
  function succeLogin(data) {
    setAuthHeader(data.accessToken, data.refreshToken); // 헤더에 토큰 생성
    authContext.onLogin(data); //권한 컨테스트 로그인 처리

    //console.log("로그인성공, 매니저 ID:" + data.lginId); //

    //window.location.href = '/main';
    navigate('/main', {replace: true})
  }

  return (
    <main className={style.main_wrap}>


      <div className={style.login_Box}>

        <div className={style.login_box__logo}>EluNIR</div>
        <div className={style.login_box__line}/>
        <div className={style.input_wrap}>
          <div className={style.id_pw_wrap}>
            <Icon id="input_id" width="24" height="24"/>
            <input className={style.id_pw__input}
                   type="text"
                   defaultValue={lginId}
                   ref={lginIdInputRef}
                   placeholder={"Id"}
                   maxLength={40}
                   onChange={(e) => setLginId(e.target.value)}
            />
          </div>
          <div className={style.id_pw_wrap}>
            <Icon id="input_pw" width="24" height="24"/>
            <input
              className={style.id_pw__input}
              type="password"
              defaultValue={userPw}
              ref={userPwInputRef}
              placeholder={"Password"}
              maxLength={20}
              onChange={(e) => setUserPw(e.target.value)}
              onKeyDown={(e) => handleKeyDown_password(e)}
              required
            />
          </div>
          <div style={{display: "flex"}}>
            <Checkbox
              id="save_id__checkbox"
              label={""}
              onChange={(e) => handleSave_id__checkbox(e)}
              checked={isRmbId}
              ref={saveIdRef}
            />
            ID저장
          </div>
          <button className={style.login__button} onClick={handleClick_Login}>LOGIN</button>
        </div>
        <div className={style.login_box__logo}>
          <Icon id="copyright_tilde" width="300" height="16"/>
        </div>
      </div>


      <Modal
        open={isModalChangePw}
        handle_Close={handleModalChangePw_Close}
        title="사용자 정보변경"
        width="736px"
        height="450px"
        isHeader={true}
        //bottomBtnText={{cancel:"취소텍스트",confirm:"확인 텍스트"}}
        bottomBtnText={{cancel: "취소", confirm: "변경(저장)"}}
        isBottom={false}>
        <COM120M1 handle_Close={handleModalChangePw_Close}
                  userId={lginId}
        />
      </Modal>
    </main>
  );
};

export default COM101F1;